import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class AppService {
	private apiURL = environment.apiURL;
	constructor(private http: HttpClient) {}


  getStudents(LId:number){
    return this.http.get(this.apiURL + 'StudentSummary/' + LId)
  }
  GetAbsentDetail(stu:any){
    return this.http.get(this.apiURL + 'StudentDailyAbsentDetails/' + stu.studentId + '/'  + stu.schoolYear)
  }
  GetUser(profile:any){
    var email = profile.replace("@yisd.net", "");
    return this.http.get(environment.apiURL + 'User/' + email)
  }
  getLocationDetail(LId: number) {
    return this.http.get(this.apiURL + 'LocationDetail/' + LId);

  }

  getAbsenceCountDailyBySchoolByYear( Lid: number, Year: number){
    return this.http.get(this.apiURL + 'DailyAbsentCount/' + Lid + '/'+Year)
  }

}
